import { Payment } from '../../types';

function getPaymentMethod(payment: Payment) {
  if (payment.bankAccountDestinationAccountType === 'Cuenta corriente') {
    if (payment.bankAccountDestinationBankCode === 1) return 1;
    else return 7;
  } else {
    if (payment.bankAccountDestinationBankCode === 1) return 6;
    else return 8;
  }
}

export default getPaymentMethod;
